import { Link } from 'react-router-dom';
import styles from './styles.module.scss';

const Footer = (props) => {

const communityArray = [];
    function Community(id, name, link) {
  this.id = id;
  this.name = name;
  this.link = link;
}
communityArray.push(new Community(1,"discord","https://discord.com/invite/BkFsXxauc4"));
communityArray.push(new Community(2,"youtube","https://www.youtube.com/@nevry-cards"));
communityArray.push(new Community(3,"ko-fi","https://ko-fi.com/nevrycards"));
    
    return (
        <div className={`${styles.backgroundColorDark} ${props.xmas && styles['backgroundColorDark--xmas']} ${props.halloween && styles['backgroundColorDark--halloween']} ${styles[`width--100P`]} ${styles[`height--10P`]}`}
        style={{
            position: 'relative',
            zIndex: 999
        }}
        >
            <div className={`${styles.linksList} ${styles.backgroundColorBlackout} ${props.xmas && styles['backgroundColorBlackout--xmas']} ${props.halloween && styles['backgroundColorBlackout--halloween']}`}>
                {communityArray.map((val)=>{return    <Link to={val.link} target="_blank" className={`${styles.linkElem}`}
                  style={{background: `url("/pictures/icons/${val.name}.png") center/cover no-repeat`}}
                  ></Link>})}

            </div>
         <div className={styles.copyright}>Nevrycards© 2021-2026</div>
        </div>
    );
}


export default Footer;